import { classnames } from 'tailwindcss-classnames';
import { ReactDesktopTabsProps } from './_types';

export const ReactDesktopTabsHorizontalLayout = ({
  tabs,
  visibleItem,
  toggleItemVisibility,
}: ReactDesktopTabsProps) => {
  return (
    <>
      <div>
        <ul
          className={classnames(`flex`, `border-solid`, `border-gray-midGray`, `border-b`)}
          data-nmdp-tabstrip="tabstrip"
        >
          {tabs.map((item) => (
            <li
              className={classnames({
                ['border-blue-navy']: item.name === visibleItem,
                'border-b-4': item.name === visibleItem,
              })}
              key={item.name}
            >
              <button
                type="button"
                className={classnames(`pt-5`, `px-[16px]`, `text-gray-darkGray`, `cursor-pointer`, {
                  ['font-semibold']: item.name === visibleItem,
                })}
                data-nmdp-tab={item?.name}
                onClick={() => toggleItemVisibility(item?.name)}
              >
                <div
                  className={classnames({
                    ['text-blue-navy']: item.name === visibleItem,
                  })}
                >
                  {item?.name}
                </div>
              </button>
            </li>
          ))}
        </ul>
        {tabs.map((item, index) => (
          <div
            className={classnames(`p-5`, `mt-2`, `w-full`, `h-full`, {
              hidden: visibleItem !== item.name,
            })}
            key={item.name}
            data-nmdp-tab={index}
          >
            {item.component}
          </div>
        ))}
      </div>
    </>
  );
};
